import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import './style.css';

const PAlert = ({
    show,
    setShow,
    title,
    body,
    isHtmlTitle = false,
    onClose = () => ({}),
    bodyStyle = {},
    footerStyle = {},
    modalStyle = {},
    ...rest
}) => {
    const handleClose = (e) => {
        setShow(false);
        onClose();
    };

    return (
        <Modal
            className="alert-modal"
            show={show}
            onHide={handleClose}
            animation={false}
            centered
            style={modalStyle}
            backdrop="static"
            {...rest}
        >
            {
                title && <Modal.Header>
                    {
                        isHtmlTitle
                            ? <Modal.Title
                                style={{ fontWeight: 'bold' }}
                                dangerouslySetInnerHTML={{ __html: title }}
                            />
                            : <Modal.Title style={{ fontWeight: 'bold' }}>{title}</Modal.Title>
                    }
                </Modal.Header>
            }
            <Modal.Body style={bodyStyle} dangerouslySetInnerHTML={{ __html: body }}></Modal.Body>
            <Modal.Footer style={footerStyle}>
                <Button variant="primary" onClick={handleClose}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PAlert;
